import script from "./GenreItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./GenreItemList.vue?vue&type=script&setup=true&lang=js"

import "./GenreItemList.vue?vue&type=style&index=0&id=93b4dbf2&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93b4dbf2"]])

export default __exports__